import { Component, inject } from '@angular/core';
import { FormSelect } from '../forms/form-select/form-select';
import { NotificationList } from '../notifications/notification-list/notification-list';
import { Layout } from '../layout/layout';
import ClientService from '../services/client.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import NotificationService from '../services/notification.service';

@Component({
  selector: 'app-dashboard',
  imports: [FormSelect, NotificationList, Layout, NgSelectModule, CommonModule],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.css',
})
export class Dashboard {
  protected clientService = inject(ClientService);

  onChangeClient(event: any) {
    if (!event) {
      this.clientService.selectedClient.set(undefined);
      return;
    }
    this.clientService.selectedClient.set(event._id);
  }

  clients$ = this.clientService.all();
}
